import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/servicenow')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/servicenow', ...ROUTE_META['/compare/servicenow'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'ServiceNow', path: '/compare/servicenow' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/servicenow', ...ROUTE_META['/compare/servicenow'] })),
    ],
  }),
});
